import { Column } from 'react-table';
import { UsersColumn } from './UsersColumn';
import { StatusColumn } from './StatusColumn';
import { CompletionColumn } from './CompletionColumn';
import { TaskLinkColumn } from './TaskLinkColumn';
import { Text } from '@cdl/heartbeat-react';
import { dateConverter } from '../../utils/task.utils';
import { AnnotationTask } from '../../../ecg/types/annotation-tasks.type';
import { EffortColumn } from './EffortColumn';
import { EffortHeader } from './EffortHeader';

export const setColumns: Column<AnnotationTask>[] = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: ({ row }) => (
      <TaskLinkColumn
        id={row.values.id}
        name={row.values.name}
        annotationTask={row.original}
      />
    ),
  },
  {
    Header: 'Completion',
    accessor: 'completion',
    Cell: ({ value: completionData }) => (
      <CompletionColumn data={completionData} />
    ),
  },
  {
    Header: 'Annotation grid',
    accessor: 'annotationGrid',
    Cell: ({ value }) => <Text fontWeight='regular'>{value}</Text>,
  },
  {
    Header: 'Users',
    accessor: 'annotators',
    Cell: ({ value: usersArray }) => <UsersColumn users={usersArray} />,
  },
  {
    Header: 'Created at',
    accessor: 'createdAt',
    Cell: ({ value }) => (
      <Text fontWeight='regular'>{dateConverter(value)}</Text>
    ),
  },
  {
    Header: 'Estimated date',
    accessor: 'eta',
    Cell: ({ row }) => (
      <Text fontWeight='regular'>
        {row.values.eta
          ? row.values.eta
          : row.original.effectiveDate
          ? dateConverter(row.original.effectiveDate).slice(0, 10) + ' [✓]'
          : '--'}
      </Text>
    ),
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row }) => (
      <StatusColumn status={row.values.status} annotationTask={row.original} />
    ),
  },
  {
    Header: <EffortHeader />,
    accessor: 'effort',
    Cell: ({ value: effort }) => <EffortColumn effort={effort} />,
  },
  {
    Header: 'Productivity',
    accessor: 'averageProductivity',
    Cell: ({ value }) => <Text fontWeight='regular'>{value ? value : 0}</Text>,
  },
  {
    accessor: 'id',
    Cell: ({ value: id }) => <TaskLinkColumn id={id} />,
  },
];
